import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { getSortableItemStyle } from './Styles';
/**
 *
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTitle: Frontend
 * @Description: Wraps a child component to make it sortable and draggable using @dnd-kit/sortable.
 *              Provides drag-and-drop functionality and visual feedback when the item is moved.
 * @param {string|number} id - Unique identifier for the sortable item (required by useSortable)
 * @param {React.ReactElement} children - The child element to render inside the sortable container.
 *                                        Receives dragHandleProps automatically for drag gestures.
 * @returns {JSX.Element}
 */
const CustomSortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition,    isDragging, } =
    useSortable({ id });

 const style = getSortableItemStyle(transform, transition, isDragging);

  return (
    <div ref={setNodeRef} style={style} {...attributes}>
      {React.cloneElement(children, { dragHandleProps: listeners,  isDragging, })}
    </div>
  );
};

export default CustomSortableItem;
